import isNumber from "lodash.isnumber";

function numberFormatter(number, ...args) {
  const numberFormat = new Intl.NumberFormat(...args);
  return numberFormat.format(number);
}

function toCurrency(number, {
  currency = "RUB",
  locale = "Ru-ru",
  style = "currency",
  ...options
} = {}) {
  if (!isNumber(number)) {
    return number;
  } // Do not display the fractional part of the currency if it is equal to zero


  const fractionDigits = (number ^ 0) === number ? 0 : 2;
  return numberFormatter(number, locale, {
    currency,
    style,
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
    ...options
  });
}

function toPercent(number, {
  currency = "RUB",
  locale = "En-en",
  style = "percent",
  maximumFractionDigits = 2,
  ...options
} = {}) {
  return numberFormatter(number, locale, {
    currency,
    style,
    maximumFractionDigits,
    ...options
  });
}

const textToNumber = text => {
  const formatedText = text.replace(/,/g, ".");
  return parseFloat(formatedText) || 0;
};
/**
 * Conversion from string to number, if empty string, then null, if not a number, then NaN
 *
 * @example
 *    "" => null
 * "abc" => NaN
 *  "15" => 15
 */


const strToInt = str => {
  return str === "" ? null : +str;
};

export { numberFormatter as default, numberFormatter, toCurrency, toPercent, textToNumber, strToInt };